module.exports = __webpack_public_path__ + "static/media/logoREACTJS.402d8a0f.svg";